import jwt_decode from "jwt-decode";
import * as actions from "../actions/index";

const checkTokenMiddleware = ({ dispatch, getState }) => {
    return (next) => (action) => {
        if (localStorage?.user) {
            const user = JSON.parse(localStorage.getItem("user"));
            const token = user.token;
            const decoded = jwt_decode(token);
            if (decoded.exp <= Date.now() / 1000) {
                dispatch(actions.userLogout());
                localStorage.removeItem("user");
            }
        }
        return next(action);
    };
};

export default checkTokenMiddleware;
